import * as React from 'react'

import { type SelectOption } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import { isNotifiable } from '../utils'
import { NotifiableSelect } from './NotifiableSelect'

interface Props {
  disabled: boolean
  form: Form
  multi?: boolean
  recipientOptions: SelectOption[]
  recipientTypeOptions: SelectOption[]
}

const CommonNotificationSelectsClass = ({
  disabled,
  form,
  multi = false,
  recipientOptions,
  recipientTypeOptions,
}: Props) => {
  const notifiable = (): boolean => isNotifiable(form.get('recipient').value)
  const showRecipient = form.get('recipient_type').value !== 'manual_selection'

  return (
    <>
      <FormRow>
        <Select
          none={i18n.t('common.select_one')}
          readonly={disabled}
          field={form.get('recipient_type')}
          label={i18n.t('automations.actions.send_notification.recipient_type.label')}
          options={recipientTypeOptions}
        />
      </FormRow>
      {showRecipient && (
        <FormRow>
          <Select
            none={i18n.t('common.select_one')}
            readonly={disabled}
            field={form.get('recipient')}
            label={i18n.t('automations.actions.send_notification.recipient.label')}
            options={recipientOptions}
          />
        </FormRow>
      )}
      {notifiable() && (
        <FormRow>
          <NotifiableSelect
            multi={multi}
            disabled={disabled}
            field={form.get('notifiable_id')}
            multiField={multi ? form.get('notifiable_ids') : undefined}
            recipient={form.get('recipient').value}
          />
        </FormRow>
      )}
    </>
  )
}

export const CommonNotificationSelects = observer(CommonNotificationSelectsClass)
